<p-tag [icon]="icon" value="" [rounded]=true [style]="{'margin-left': '10px'}" [pTooltip]="text"></p-tag>
